var lazyload = {

	addSource: function(img) {
		var _this = this;

		// Mobile Image ( - 991px )
		if ( Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") ) {
			img.each(function () {
				$(this).attr("data-original",  $(this).attr('data-mobileImage'));
			});
		} 
		// Desktop image (992px + )
		else {
			img.each(function () {
				$(this).attr("data-original",  $(this).attr('data-fullImage'));
			});
		}
	},

	load:function(img) {
		var _this = this;

		img.each(function() {
			var img = $(this);
			if ( img.hasClass('loaded') ) { return; }
			if ( Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") && img.hasClass('mobile-hidden') ) { return; }

			// === Load Image
			img.lazyload({
				effect: "fadeIn",
				effectspeed: 500,
				threshold: 200,
				load: function() {
					$(this).removeClass('loading');
					$(this).addClass('loaded');
					if ( $(this).attr('data-lz-class','parent') ) {
						$(this).parent().removeClass('loading');
					}
				}
			});
		})

	},

	init: function() {

		var _this = this;

		// _this.img = $("img.lazyload");
		// _this.bgImg = $("div.lazyload");

		_this.el = $(".lazyload");

		if ( _this.el.length < 1 ) { return; }

		_this.addSource(_this.el);
		_this.load(_this.el);
		$(window).smartresize(function() {
			_this.load(_this.el);
		})

	}
}